import Image from 'next/image';
import { type ReactElement } from 'react';

import { SIZE } from '@/components/atoms/Button/Button.types';

import {
  StickyButtonContent,
  StickyButtonWrapper,
  StickyCtaButton,
  StickyThumbnail,
  StickyTitle,
} from './StickyBuyButton.styled';

interface StickyButtonProps {
  isVisible: boolean;
  onClick?: () => void;
}

export const StickyBuyButton = ({
  isVisible,
  onClick,
}: StickyButtonProps): ReactElement => (
  <StickyButtonWrapper isVisible={isVisible}>
    <StickyButtonContent onClick={onClick}>
      <StickyThumbnail>
        <Image
          src="/static/images/teneryfa/price-1.jpg"
          alt="Okładka przewodnika po Teneryfie"
          fill
          sizes="44px"
          style={{ objectFit: 'contain' }}
        />
      </StickyThumbnail>
      <StickyTitle>
        <span>Teneryfa.</span>
        <span>Praktyczny przewodnik</span>
      </StickyTitle>
      <StickyCtaButton size={SIZE.SMALL}>Pobierz przewodnik →</StickyCtaButton>
    </StickyButtonContent>
  </StickyButtonWrapper>
);
